import { CASE_TYPE } from '@demandproai/shared';
import { generateRandomIds } from './helper';

const defaultDefendant = {
    defendantId: '',
    personalInfo: {
        name: ""
    },
    insurance: {
        insuranceName: '',
        claimNumber: '',
        adjuster: {
            name: '',
            phoneNumber: '',
            email: '',
            address: '',
            city: '',
            state: '',
            zip: ''
        }
    },
    result: {
        policeReportResponse: '',
        witnessStatementsResponse: '',
        incidentReportResponse: '',
        expertSafetyReportResponse: '',
        factsOfIncidentLLMResponse: '',
        dangerousConditionLLMResponse: '',
        actualConstructedNoticeLLMResponse: ''
    }
};

export function getDefaultDefendant() {
    const result = structuredClone(defaultDefendant);
    result.defendantId = generateRandomIds();
    return result;
}

export const defaultClient = {
    clientId: '',
    personalInfo: {
        clientName: "",
        phoneNumber: '',
        email: '',
        ssn: '',
        gender: '',
        age: 0
    },
    insurance: {
        insuranceName: '',
        claimNumber: '',
        adjuster: {
            name: '',
            phoneNumber: '',
            email: '',
            address: '',
            city: '',
            state: '',
            zip: ''
        }
    },
    medicalProviders: {
        postAccident: {
            medicalRecords: [],
            result: {
                visitDates: [],
                executiveSummary: '',
                lifecarePlan: '',
                lifecarePlanTotalCost: 0,
                medicalRecordsParagraphs: '',
                simplifiedTreatmentParagraphs: '',
                textExtractions: [],
                medicalBillRecords: [],
                medicalRecordsExhibitDirectoryPath: [],
                medicalRecords: []
            }
        },
        preAccident: {
            medicalRecords: [],
            result: {
                visitDates: [],
                medicalRecordsParagraphs: '',
                medicalRecordsExhibitDirectoryPath: [],
                textExtractions: [],
                medicalRecords: []
            }
        }
    },
    damage: {
        isProcessLifeCarePlan: true,
        workHoursMissed: 0,
        hourlyIncomeRate: 0,
        typeofWork: '',
        lossOfEarning: [],
        futureMedicalExpense: []
    },
    painAndSuffering: {
        monthlyamount: 0,
        annualamount: 0,
        isPastTotalAmount: false,
        isFutureTotalAmount: false,
        totalPastAmount: 0,
        totalFutureAmount: 0,
        descriptionText: '',
        bodilyInjuriesImageFiles: [],
        selectedPainPoints: [],
        result: {
            painAndSufferingReport: '',
            postAmount: '',
            priorAmount: '',
            perDayPriorAmount: '',
            perDayPostAmount: ''
        }
    },
    result: {
        lifecarePlan: {
            s3FilePath: '',
            exhibitPagesS3UrlPaths: []
        }
    }
};

export function getDefaultClient() {
    const result = structuredClone(defaultClient);
    result.clientId = generateRandomIds();
    return result;
}

const defaultCaseInfo = {
    caseName: '',
    caseType: CASE_TYPE.AUTO_ACCIDENT,
    dateOfIncident: '',
    stateOfIncident: '',
    isIncludeExhibit: false,
    isSingleLiabilitySectionForAllDefendants: true,
    letterOfProtection: null
}

export function getDefaultCaseInfo() {
    return defaultCaseInfo;
}

export const defaultMedicalProviders = {
    postAccident: {
        medicalRecords: []
    },
    preAccident: {
        medicalRecords: []
    }
};

export const defaultDamage = {
    isProcessLifeCarePlan: true,
    workHoursMissed: 0,
    hourlyIncomeRate: 0,
    typeofWork: '',
    lossOfEarning: [],
    futureMedicalExpense: []
};

export const defaultPainAndSuffering = {
    monthlyamount: 0,
    annualamount: 0,
    isPastTotalAmount: false,
    isFutureTotalAmount: false,
    totalPastAmount: 0,
    totalFutureAmount: 0,
    descriptionText: '',
    bodilyInjuriesImageFiles: [],
    selectedPainPoints: [],
    result: {
        painAndSufferingReport: '',
        postAmount: '',
        priorAmount: '',
        perDayPriorAmount: '',
        perDayPostAmount: ''
    }
};

export const defaultLiability = {
    howincidentOccured: [],
    dangerousConditions: [],
    factsRegardingNotice: [],
    witnessStatements: [],
    incidentReports: [],
    accidentSceneFiles: [],
    policeReportData: [],
    expertSafetyReport: []
};